import React, { useState } from 'react';
import { Form, Button, Col, Alert, InputGroup } from 'react-bootstrap';
import { FaUser, FaLock } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Swal from 'sweetalert2';

const FormAuth = () => {
    const navigate = useNavigate();

    const { error, authPost, auth } = useAuth();
    const [authData, setAuthData] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setAuthData((auth) => ({
            ...auth,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const token = await authPost(authData)
      
        if (token?.status == 400 || token === undefined) {
            Swal.fire({
                icon: 'error',
                title: 'Login Failed',
                text: 'Incorrect email or password. Please try again.',
            });
        } else {
            Swal.fire({
                icon: 'success',
                title: 'Login Successful!',
                text: 'Welcome back!',
                confirmButtonText: 'OK',
            }).then((result) => {
                localStorage.setItem("token", token?.token);
                if (result.isConfirmed) {
                    navigate('/'); // Navigate to dashboard or any page
                }
            });
        }
    };

    return (
        <Col>
            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3 auth-field-group">
                    <Form.Label className="auth-field-label">Username</Form.Label>
                    <InputGroup className="auth-input-group">
                        <InputGroup.Text className="auth-input-icon">
                            <FaUser />
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            name="username"
                            placeholder="Enter username"
                            value={authData.username}
                            onChange={handleChange}
                            required
                        />
                    </InputGroup>
                </Form.Group>

                <Form.Group className="mb-4 auth-field-group">
                    <Form.Label className="auth-field-label">Password</Form.Label>
                    <InputGroup className="auth-input-group">
                        <InputGroup.Text className="auth-input-icon">
                            <FaLock />
                        </InputGroup.Text>
                        <Form.Control
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={authData.password}
                            onChange={handleChange}
                            required
                        />
                    </InputGroup>
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100 auth-submit-btn">
                    Login
                </Button>
            </Form>
        </Col>
    );
};

export default FormAuth;
